/**
 * Load vega / vega-lite / vega-embed UMD from jsDelivr.
 * Vue CLI 4 + webpack 4 do not bundle vega-embed v7 (pure ESM) reliably.
 */
const VEGA_CDN_SCRIPTS = [
  'https://cdn.jsdelivr.net/npm/vega@5.30.0/build/vega.min.js',
  'https://cdn.jsdelivr.net/npm/vega-lite@5.21.0/build/vega-lite.min.js',
  'https://cdn.jsdelivr.net/npm/vega-embed@6.26.0/build/vega-embed.min.js'
];

let cdnChain = null;

function appendScriptOnce(src) {
  return new Promise((resolve, reject) => {
    const existing = Array.from(document.scripts).find(
      (node) => node.src === src || node.getAttribute('src') === src
    );
    if (existing) {
      if (existing.getAttribute('data-vega-cdn-loaded') === '1') {
        resolve();
        return;
      }
      existing.addEventListener('load', () => resolve());
      existing.addEventListener('error', () => reject(new Error(src)));
      return;
    }
    const s = document.createElement('script');
    s.src = src;
    s.async = true;
    s.onload = () => {
      s.setAttribute('data-vega-cdn-loaded', '1');
      resolve();
    };
    s.onerror = () => reject(new Error(`Failed to load ${src}`));
    document.head.appendChild(s);
  });
}

export function loadVegaEmbedFromCdn() {
  if (typeof window === 'undefined') {
    return Promise.reject(new Error('no window'));
  }
  if (window.vegaEmbed) {
    return Promise.resolve(window.vegaEmbed);
  }
  if (cdnChain) return cdnChain;
  cdnChain = VEGA_CDN_SCRIPTS.reduce(
    (p, src) => p.then(() => appendScriptOnce(src)),
    Promise.resolve()
  )
    .then(() => {
      if (!window.vegaEmbed) {
        throw new Error('vegaEmbed not available after loading CDN scripts');
      }
      return window.vegaEmbed;
    })
    .catch((err) => {
      cdnChain = null;
      throw err;
    });
  return cdnChain;
}
